
import alumniLogo from '@/assets/alumnilogo2.png';

interface NavigationProps {
  activeSection: string;
  onNavigate: (section: string) => void;
}

export default function Navigation({ activeSection, onNavigate }: NavigationProps) {
  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'team', label: 'Team' },
    { id: 'events', label: 'Events' },
    { id: 'join', label: 'Join' },
    { id: 'contact', label: 'Contact' }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-100 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <button
              onClick={() => onNavigate('home')}
              className="hover:opacity-80 transition-opacity cursor-pointer"
            >
              <img 
                src={alumniLogo}
                alt="Cambridge JBS Alumni Türkiye"
                className="h-14 w-auto object-contain"
              />
            </button>
          </div>
          
          <div className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => onNavigate(item.id)}
                className={`px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeSection === item.id
                    ? 'text-teal-700 border-b-2 border-teal-700'
                    : 'text-gray-700 hover:text-teal-700'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          <div className="md:hidden">
            <button className="text-gray-700 hover:text-teal-700 cursor-pointer">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
